/* eslint-disable */
import { Suspense, useEffect, useState } from 'react';
import { subTabs } from './SubTabs';
import styles from './AiPacakging.module.scss';

function TabComp(props) {
	const { value, handleExport, data, filters, parentValue, handleSortColumn, sortColumn, sortType , openModal} = props;
	const [active, setActive] = useState(()=>{
		return subTabs?.[parentValue]?.[0];
	});

	// Update active tab when parentValue changes
	useEffect(() => {
		setActive(subTabs?.[parentValue]?.[0]);
	}, [parentValue]);

	const handleTabs = (tabsData) => {
		setActive(tabsData);
	};

	return (
		<>
			<div 
  				className={`w-full max-w-full overflow-x-auto flex m-[12px] rounded-md bg-[#FDE6AD] h-[45px] ${styles.customScroll}`}
			> 
 		 		{data.length > 0 && (
    				subTabs?.[parentValue]?.map?.((ele) => { 
      				const isActive = active?.id === ele?.id; 
     				return ( 
        			<div 
          				className={`text-center text-nowrap flex-1 px-[7px] flex items-center justify-center text-[14px] md:text-base 
            					font-medium cursor-pointer
            					${isActive ? 'bg-[#ffb703]' : 'border border-[#00000033]'}
          						`}
          				onClick={() => handleTabs(ele)}
        			> 
          				{ele?.header} 
        			</div> 
      				); 
    				})
  				)} 
			</div>
			<Suspense fallback={<div>loading ...</div>}>
				{active?.comp?.({
					parentValue,
					value,
					subValue: active.value,
					handleTabs,
					handleExport,
					data,
					filters,
					handleSortColumn,
					sortColumn,
					sortType,
					openModal,
				})}
			</Suspense>
		</>
	);
}
export default TabComp;
